<script setup lang="ts">
  import { DefaultTable, TableHeader } from '@/shared/ui';
  import type { VisibleDirectoryItem } from '../model/visible-tree.types';

  defineProps<{
    matrices: VisibleDirectoryItem[];
  }>();

  const getMatrixKey = (matrix: VisibleDirectoryItem): string =>
    matrix.linkId !== null ? `link-${matrix.linkId}` : `matrix-${matrix.itemId}`;

  const getMatrixPrefix = (matrix: VisibleDirectoryItem): string => matrix.prefix ?? '-';

  const getMatrixTitle = (matrix: VisibleDirectoryItem): string =>
    matrix.name ?? `Matriz ${matrix.itemId}`;
</script>

<template>
  <section
    v-if="matrices.length > 0"
    class="w-full mt-8"
    data-testid="folder-matrices"
  >
    <DefaultTable
      table-class="w-full table-fixed"
      class="divide-y divide-gray-02 min-w-full"
    >
      <thead class="bg-white-01 divide-y divide-gray-02">
        <tr>
          <th
            colspan="2"
            class="px-6 py-4.5 text-left text-base font-semibold text-gray-07"
          >
            Matrizes
          </th>
        </tr>
        <tr>
          <TableHeader
            text="Prefixo"
            class="text-xs/5"
          />
          <TableHeader
            text="Título"
            class="text-xs/5"
          />
        </tr>
      </thead>
      <tbody class="bg-white-01 divide-y divide-gray-02 border-t border-gray-02">
        <tr
          v-for="matrix in matrices"
          :key="getMatrixKey(matrix)"
          class="table-row-hover border-t border-gray-02"
          data-testid="folder-matrix-row"
        >
          <td class="pl-6 py-4.5 text-sm text-gray-07">
            {{ getMatrixPrefix(matrix) }}
          </td>
          <td class="pl-6 py-4.5 pr-6">
            <span class="block truncate text-sm text-gray-07">
              {{ getMatrixTitle(matrix) }}
            </span>
          </td>
        </tr>
      </tbody>
    </DefaultTable>
  </section>
</template>
